import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { createSafeStylesAccessor } from '../../helpers/cssHelpers';

function AxisTitle({ width, orientation, children }) {
  const { get } = useReportConfiguration();
  const safeStyles = createSafeStylesAccessor(get() || {});

  // Use explicit format getter based on orientation
  const titleStyle =
    orientation === 'horizontal'
      ? safeStyles.getHorizontalAxisTitleFormat()
      : safeStyles.getVerticalAxisTitleFormat();

  return (
    <span
      style={{
        width,
        ...titleStyle,
      }}
      className={`axis__title axis__title--${orientation}`}
    >
      {children}
    </span>
  );
}

export default AxisTitle;
